import React, { createContext, useState, useEffect } from 'react';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  // Initialize cart from localStorage or default to an empty array
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem('cart');
    return savedCart ? JSON.parse(savedCart) : [];
  });

  // Save cart to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  // Function to add an item to the cart
  const addToCart = (item) => {
    setCart(prevCart => [...prevCart, item]);
  };

  // Function to get the number of items in the cart
  const getCartCount = () => cart.length;

  const removeFromCart = (itemId) => {
    setCart(prevCart => prevCart.filter(item => item.id !== itemId));
  };
  const clearCart = () => {
    setCart([]);
  };
  return (
      <CartContext.Provider value={{ cart, addToCart, getCartCount, removeFromCart,clearCart }}>
      {children}
    </CartContext.Provider>
  );
};
